import useAnalyticsSync from '@/app/analytics/useAnalyticsSync';
import useStatsAnalytics from '@/app/analytics/useStatsAnalytics';

interface AnalyticsSyncProps {
  // False once the call is over. The component stays mounted through the
  // feedback dialog, and metrics from a call that has ended are nobody's.
  isCallLive?: boolean;
}

export default function AnalyticsSync({ isCallLive = true }: AnalyticsSyncProps) {
  useAnalyticsSync(isCallLive);
  useStatsAnalytics();

  return null;
}
